module.exports = __webpack_public_path__ + "img/img09.3a274b22.svg";